var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star_solid",
    transform: "translate(-1.99 -2.599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12780",
    "data-name": "Path 12780",
    d: "M9.982,5.309C10.855,3.5,11.291,2.6,11.99,2.6s1.135.9,2.007,2.71l1.509,3.125,3.5.588c1.822.306,2.732.459,2.945,1.1s-.423,1.312-1.7,2.658L17.68,15.5l.546,3.659c.288,1.928.432,2.893-.131,3.291s-1.418-.061-3.128-.981l-2.977-1.6-2.977,1.6c-1.711.92-2.566,1.38-3.128.981s-.419-1.363-.131-3.291L6.3,15.5,3.725,12.779c-1.272-1.346-1.908-2.019-1.7-2.658s1.123-.792,2.945-1.1l3.5-.588Z",
    transform: "translate(0)",
    fill: "#c2c2c2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSolid);
export default __webpack_public_path__ + "static/media/star_solid.3f5306361628bf6daa2633555ae8144d.svg";
export { ForwardRef as ReactComponent };